module.exports = __webpack_public_path__ + "img/apps.7cf390d3.svg";